import isNil from "lodash.isnil";
import { formatCurrency } from "@/helpers/currency";
import { isTime, parseDate, parseDatetime } from "@/helpers/dates";
import { percent } from "@/helpers/filters";

export default {
    string: {
        value: (val) => val,
        format: (val) => val,
    },
    stringlist: {
        value: (val) => val,
        format: (val) => (val ? val.join(", ") : ""),
    },
    stringlines: {
        value: (val) => val,
        format: (val) => (val ? val.join("<br>") : ""),
    },
    int: {
        value: (val) => parseInt(val),
        format: (val) => val,
    },
    float0: {
        value: (val) => parseFloat(val),
        format: (val) => parseFloat(val)?.toFixed(0) || null,
    },
    float1: {
        value: (val) => parseFloat(val),
        format: (val) => parseFloat(val)?.toFixed(1) || null,
    },
    float2: {
        value: (val) => parseFloat(val),
        format: (val) => parseFloat(val)?.toFixed(2) || null,
    },
    coords: {
        value: (val) => parseFloat(val),
        format: (val) => parseFloat(val)?.toFixed(6) || null,
    },
    km: {
        value: (val) => parseFloat(val),
        format: (val) => {
            if (isNil(val)) {
                return null;
            }
            return `${parseFloat(val)?.toFixed(2)} km`;
        },
    },
    currency: {
        value: (val) => parseFloat(val),
        format: (val, item, field) => {
            let currency = field?.currency || item?.currency || "EUR";
            if (typeof currency === "function") {
                currency = currency(item);
            }
            return formatCurrency(val, currency);
        },
    },
    percent: {
        value: (val) => parseFloat(val),
        format: (val) => percent(val),
    },
    date: {
        value: (val) => parseDate(val),
        format: (val) => val,
    },
    time: {
        value: (val) => (isTime(val) ? val.split(":").map((x) => parseInt(x)) : [0, 0]),
        format: (val) => val,
    },
    datetime: {
        value: (val) => parseDatetime(val),
        format: (val) => {
            if (val.includes("T")) {
                return new Date(val).toLocaleString();
            }
            return val;
        },
    },
    check: {
        value: (val) => val,
        format: (val) => (val ? "✔" : ""),
    },
    link: {
        value: (val) => {
            if (!isNil(val) && typeof val === "object") {
                return val.label;
            }
            return val;
        },
        format: (val) => {
            if (!isNil(val) && typeof val === "object") {
                return val.label;
            }
            return val;
        },
    },
    bucketfile: {
        value: (val) => val,
        format: (val) => val?.filename || "",
    },
    choices: {
        value: (val) => val,
        format: (val) => val,
    },
    rating: {
        value: (val) => val,
        format: (val) => {
            switch (val) {
                case 0:
                    return "";
                case 1:
                    return "★";
                case 2:
                    return "★★";
                case 3:
                    return "★★★";
                case 4:
                    return "★★★★";
                case 5:
                    return "★★★★★";
                default:
                    return "";
            }
        },
    },
};
